import { useMutation } from '@tanstack/react-query';
import waitlistPublicApi from '@/features/public/waitlist/api/waitlistPublicApi.ts';
import { CreateWaitlistEntryResponseDto } from '@/features/public/waitlist/types/CreateWaitlistEntryResponseDto.ts';
import { WaitlistForm } from '@/features/public/waitlist/schemas/waitlistSchema.ts';
import { waitlistEntryDtoMapper } from '@/features/public/waitlist/types/CreateWaitlistEntryDto.mapper.ts';
import { toast } from 'sonner';
import { useRouter } from '@tanstack/react-router';
import { queryClient } from '@/App.tsx';
import { waitlistPublicApiQueryKeys } from '@/features/public/waitlist/api/waitlistPublicApi.queryKeys.ts';
import { isWaitlistNotAvailableError } from '@/features/public/booking/api/bookingErrors.ts';

interface CreateWaitlistEntryParams {
  orgSlug: string;
  tourSlug: string;
  form: WaitlistForm;
}

export const useCreateWaitlistEntry = () => {
  const router = useRouter();

  return useMutation<
    CreateWaitlistEntryResponseDto,
    Error,
    CreateWaitlistEntryParams
  >({
    mutationFn: async ({ orgSlug, tourSlug, form }) => {
      const dto = waitlistEntryDtoMapper.fromFormToDto(form);
      return waitlistPublicApi.createEntry(orgSlug, tourSlug, dto);
    },
    onError: async (error: Error, { orgSlug, tourSlug }) => {
      // Okno listy zamknęło się w trakcie wypełniania formularza. Świeże
      // `basicInfo` z `waitlistAvailable: false` odeśle klienta na stronę
      // rezerwacji, gdzie zobaczy właściwy powód.
      if (isWaitlistNotAvailableError(error)) {
        await queryClient.invalidateQueries({
          queryKey: waitlistPublicApiQueryKeys.basicInfo(orgSlug, tourSlug),
        });
        await router.invalidate();
      }
      toast.error('Coś poszło nie tak', {
        description: error.message,
      });
    },
  });
};
